import { createSelector } from 'reselect';

// Types
import { RootState } from 'types/RootState.types';

// Config
import {
  getUserAddressSelector,
  getMyJLContentIndexSelector,
  getMyJLMemberStatusSelector,
  getMyJLModalOpenSelector,
} from '@redux/reducers/create-account/createAccountSelector';
import {
  getLoqateApiKeySelector,
} from '@redux/reducers/config/configSelector';
import {
  getSessionExpiredAnnouncedSelector,
} from '@redux/reducers/app/appSelector';
import {
  getSessionIdSelector,
} from '@redux/reducers/bff/bffSelector';
import { isInternational } from '@redux/reducers/payment/orderFormReducer';
import { isApps } from '@redux/reducers/app/appReducer';
import shouldShowFullScreenSignUp from '@utils/myjl/fullScreenSignUp';
import { isFeatureActive } from '@redux/reducers/config/configReducer';
import featureConstants from '@constants/featureConstants';

const getIsInternationalSelector = (state: RootState) => isInternational(state);
const getIsAppsSelector = (state: RootState) => isApps(state);
const getShouldShowFullScreenSignUpSelector = (state: RootState) => shouldShowFullScreenSignUp(state);
const getAllowMyJlSignUpsFeatureActive = (state: RootState) => isFeatureActive(
  state,
  featureConstants.ALLOW_MY_JL_SIGN_UPS,
);

export default createSelector(
  [
    getUserAddressSelector,
    getMyJLContentIndexSelector,
    getMyJLMemberStatusSelector,
    getLoqateApiKeySelector,
    getSessionExpiredAnnouncedSelector,
    getSessionIdSelector,
    getIsInternationalSelector,
    getIsAppsSelector,
    getMyJLModalOpenSelector,
    getShouldShowFullScreenSignUpSelector,
    getAllowMyJlSignUpsFeatureActive,
  ], (
    userAddress,
    myJLContentIndex,
    myJLMemberStatus,
    loqateApiKey,
    sessionExpiredAnnounced,
    sessionId,
    isInternationalAddress,
    isApps,
    myJLModalOpen,
    showFullScreenSignup,
    allowMyJlSignUps,
  ) => ({
    userAddress,
    myJLContentIndex,
    myJLMemberStatus,
    loqateApiKey,
    sessionExpiredAnnounced,
    sessionId,
    isInternationalAddress,
    isApps,
    showMyJLModal: myJLModalOpen && !showFullScreenSignup,
    showFullScreenSignup,
    allowMyJlSignUps,
  }),
);
